import Button from 'components/Button';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { MaintenanceDefault } from 'resources/img/MaintenanceDefault';
import logo from 'resources/img/logo.png';
import Auth from 'services/auth0';
import { getItem, LocalStorageKey, removeItem } from 'services/persistentData';
import styled from 'styled-components';

interface IProps {}

const PasswordExpired = ({}: IProps) => {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(false);

    const email = useMemo(() => getItem(LocalStorageKey.EXPIRED_PASSWORD_EMAIL), []);

    useEffect(() => {
        removeItem(LocalStorageKey.EXPIRED_PASSWORD_EMAIL);
    }, []);

    const onClick = async () => {
        setLoading(true);
        try {
            await Auth.sendResetPasswordEmail({ email });
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };
    if (!email) return <Redirect to="/login" />;
    return (
        <>
            <Header>
                <img src={logo} width={114} alt="Foodi Services" />
            </Header>
            <Container>
                <ContainerText>
                    <Title>{t(`error:passwordExpired.title`)}</Title>
                    <Text>{t(`error:passwordExpired.description`)}</Text>
                    <Text>{t(`error:passwordExpired.hasBeenSent`)}</Text>
                    <StyledButton isLoading={loading} onClick={onClick}>
                        {t(`error:passwordExpired.resendEmail`)}
                    </StyledButton>
                    <Text>
                        <Text style={{ fontSize: 15 }}>
                            {t(`error:passwordExpired.inCaseOfProb`)}{' '}
                            <a style={{ color: '#0084FF' }} href="mailto:help@foodi.fr" color="red">
                                help@foodi.fr
                            </a>
                        </Text>
                    </Text>
                    <Text style={{ fontSize: 15 }}>{t(`error:passwordExpired.seeYouSoon`)}</Text>
                </ContainerText>
                <MaintenanceDefault />
            </Container>
        </>
    );
};

export default PasswordExpired;

const Header = styled.div`
    padding: ${({ theme }) => theme.spacing.m}px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.color.common.white};
    background-color: ${({ theme }) => theme.color.common.navy};
`;

const Title = styled.div`
    color: ${({ theme }) => theme.color.common.navy};
    font-size: 30px;
    margin-top: 20px;
    margin-bottom: 10px;
    line-height: 60px;
    font-weight: 600;
`;

const Text = styled.div`
    color: ${({ theme }) => theme.color.common.navy};
    font-size: 22px;
    margin-bottom: 8px;
`;

const Container = styled.div`
    margin-left: 150px;
`;

const ContainerText = styled.div`
    align-items: flex-start;
`;

const StyledButton = styled(Button)`
    color: black;
    background-color: rgb(244, 184, 58);
    text-transform: none;
    &:hover:not(:disabled),
    &:active {
        background-color: rgb(244, 184, 58);
        color: black;
    }
    margin: 15px 0;
`;
